$('.login-banner').click(function (evt) {
  $('.premium-register-container').detach().appendTo('body');
  $('.premium-register-container').css('display', 'flex');
});
$('.premium-register-container .deny-button').click(function (e) {
  $('.premium-register-container').css('display', 'none');
});

$('.premium-register-container').click(function (e) {
  $('.premium-register-container').css('display', 'none');
});

$('.close-button').click(function (e) {
  $('.premium-register-container').css('display', 'none');
});

$('.premium-register-container .accept-button').click(function (e) {
  $('.premium-register-container').css('display', 'none');
  jQuery
    .getJSON('/cart.js')
    .then((res) => {
      localStorage.setItem('cartItems', JSON.stringify(res.items));
      const itemUpdate = res.items.reduce((obj, item) => Object.assign(obj, { [item.id]: 0 }), {});
      itemUpdate[variant_id_premium_product] = 1;

      jQuery
        .post('/cart/clear.js')
        .then((res) => {
          jQuery
            .post('/cart/add.js', {
              items: [
                {
                  quantity: 1,
                  id: variant_id_premium_product,
                  selling_plan: premium_product_selling_plan,
                },
              ],
            })
            .then((res) => (window.location.href = '/cart'))
            .catch((err) => {});
        })
        .catch((err) => {});
    })
    .catch((err) => {});
});

function setBreadcrumRecover() {
  $('#breadcrumb-login-top').text('パスワードをリセットする');
  $('#breadcrumb-login-bottom').text('パスワードをリセットする');
}

function setBreadcrumLogin() {
  $('#breadcrumb-login-top').text('ログイン');
  $('#breadcrumb-login-bottom').text('ログイン');
}

$(document).ready(function () {
  const currentUrlRecover = window.location.href.replace('https://', '');

  if (currentUrlRecover.substring(currentUrlRecover.search('/')) === '/account/login#recover') {
    $('#breadcrumb-login-top').text('パスワードをリセットする');
    $('#breadcrumb-login-bottom').text('パスワードをリセットする');
  }
});

function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
}
